import React, { useState } from 'react';
import { Moon, Sun, Search, X, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from './ThemeContext';

const CATEGORY_LABELS = {
  tr: {
    başlangıçlar: "Başlangıçlar",
    salata_çeşitleri: "Salatalar",
    makarna_çeşitleri: "Makarna",
    ana_sıcaklar: "Ana Yemekler",
    meşrubatlar: "Meşrubatlar",
    rakı_çeşitleri: "Rakı",
    şarap_çeşitleri: "Şarap",
    bira_çeşitleri: "Bira",
  },
  en: {
    başlangıçlar: "Appetizers",
    salata_çeşitleri: "Salads",
    makarna_çeşitleri: "Pasta",
    ana_sıcaklar: "Main Courses",
    meşrubatlar: "Beverages",
    rakı_çeşitleri: "Rakı",
    şarap_çeşitleri: "Wine",
    bira_çeşitleri: "Beer",
  }
};

const menuData = {
  başlangıçlar: [
    {
      name: "Günlük Taze Meze Çeşitleri", nameEn: "Daily Fresh Meze Varieties", price: 280,
      description: "Aşçının günlük seçimine göre değişir",
      descriptionEn: "Changes daily based on chef's selection"
    },
    {
      name: "Peynir Tahtası", nameEn: "Cheese Board", price: 800,
      description: "Yerli ve ithal peynir çeşitleri, bal ve ceviz ile",
      descriptionEn: "Local & imported cheese varieties with honey & walnuts"
    },
    { name: "Izgara Hellim", nameEn: "Grilled Halloumi", price: 600, description: "Izgara halloumi, özel baharatlarla", descriptionEn: "Grilled halloumi, special seasoning" },
    { name: "Sigara Böreği", nameEn: "Fried Cheese Rolls", price: 350, description: "Sigara böreği, özel baharatlarla", descriptionEn: "Fried cheese rolls, special seasoning" },
    {
      name: "Kalamar Tava", nameEn: "Fried Calamari", price: 900,
      description: "Tarator sos ile servis edilir",
      descriptionEn: "Served with tarator sauce"
    },
    {
      name: "Cazır Cuzur (Özel Soslu Karides)", nameEn: "Sizzling Shrimp (Special Sauce)", price: 900,
      description: "Butanlı serviste, özel baharatlı sos ile",
      descriptionEn: "Served sizzling in cast iron, with special spicy sauce"
    },
    {
      name: "Sardalya Firit", nameEn: "Fried Sardines", price: 450,
      description: "Taze sardalya, çıtır kızartılmış",
      descriptionEn: "Fresh sardines, crispy fried"
    },
  ],
  salata_çeşitleri: [
    {
      name: "Mevsim Salata", nameEn: "Seasonal Salad", price: 400,
      description: "Günlük taze sebzeler", descriptionEn: "Daily fresh vegetables"
    },
    {
      name: "Çoban Salata", nameEn: "Shepherd's Salad", price: 400,
      description: "Domates, salatalık, biber, maydanoz",
      descriptionEn: "Tomato, cucumber, pepper, parsley"
    },
    {
      name: "Greek Salad", nameEn: "Greek Salad", price: 480,
      description: "Beyaz peynir, siyah zeytin, domates, salatalık",
      descriptionEn: "Feta, black olives, tomato, cucumber"
    },
    {
      name: "Roka Parmesan", nameEn: "Arugula & Parmesan", price: 600,
      description: "Taze roka, parmesan kavak, zeytinyağı ve limon",
      descriptionEn: "Fresh arugula, parmesan shavings, olive oil & lemon"
    },
    {
      name: "Çıtır Tavuk Salata", nameEn: "Crispy Chicken Salad", price: 540,
      description: "Çıtır tavuk, mevsim yeşillikler, özel sos",
      descriptionEn: "Crispy chicken, mixed greens, house dressing"
    },
  ],
  makarna_çeşitleri: [
    {
      name: "Penne Arabiatta", nameEn: "Penne Arrabbiata", price: 450,
      description: "Acılı domates sos", descriptionEn: "Spicy tomato sauce"
    },
    {
      name: "Tavuklu Tagliatelle", nameEn: "Chicken Tagliatelle", price: 580,
      description: "Izgara tavuk, krema sos", descriptionEn: "Grilled chicken, cream sauce"
    },
    {
      name: "Spagetti Bolognese", nameEn: "Spaghetti Bolognese", price: 580,
      description: "Kıymalı et sosu", descriptionEn: "Ground beef meat sauce"
    },
    {
      name: "Spagetti Napoliten", nameEn: "Spaghetti Napolitan", price: 450,
      description: "Taze domates sosu", descriptionEn: "Fresh tomato sauce"
    },
  ],
  ana_sıcaklar: [
    {
      name: "Tavuk Külbastı", nameEn: "Chicken Külbastı", price: 750,
      description: "Marine edilmiş tavuk göğüsü, ızgarada üstün pişirilmiş",
      descriptionEn: "Marinated chicken breast, perfectly grilled"
    },
    {
      name: "Et Külbastı", nameEn: "Beef Külbastı", price: 950,
      description: "Dana kıyması, marine edilmiş ve ızgarada pişirilmiş",
      descriptionEn: "Beef chops, marinated & grilled to perfection"
    },
    {
      name: "Yonca Special Et Tahtası", nameEn: "Yonca Special Meat Platter", price: 1250,
      description: "Antrikot, bonfile ve köfte kombinasyonu",
      descriptionEn: "Entrecôte, tenderloin & meatball combination"
    },
    {
      name: "Annemin Köftesi", nameEn: "Mom's Meatballs", price: 800,
      description: "Patates kızartması ile servis edilir",
      descriptionEn: "Served with french fries"
    },
    {
      name: "Efes Kebab (Kargıda Kuzu Çöp Şiş)", nameEn: "Efes Kebab (Lamb Shish)", price: 900,
      description: "Kuzu eti, nar ekşisi ve baharatlarla marine edilmiş",
      descriptionEn: "Lamb marinated with pomegranate & spices"
    },
    {
      name: "Izgara Antrikot", nameEn: "Grilled Entrecôte", price: 1400,
      description: "Dana antrikot, ızgarada mükemmel pişirilmiş",
      descriptionEn: "Premium beef entrecôte, perfectly grilled"
    },
    {
      name: "Yonca Kavurma", nameEn: "Yonca Roasted Meat", price: 1600,
      description: "Geleneksel taş fırında, yavaş pişirilmiş et, içinde sebzeler",
      descriptionEn: "Traditional stone oven slow-roasted meat with vegetables"
    },
    {
      name: "Izgara Adana Köfte", nameEn: "Grilled Adana Kofte", price: 800,
      description: "Adana usulü, baharat ve kırmızı biber ile marine edilmiş",
      descriptionEn: "Adana style, marinated with spices & red pepper"
    },
    {
      name: "Köri Soslu Tavuk", nameEn: "Chicken in Curry Sauce", price: 800,
      description: "Tavuk göğsü, köri sos ile",
      descriptionEn: "Chicken breast, curry sauce"
    }
  ],
  meşrubatlar: [
    { name: "Coca Cola", nameEn: "Coca Cola", price: 110 },
    { name: "Coca Cola Zero", nameEn: "Coca Cola Zero", price: 110 },
    { name: "Fanta", nameEn: "Fanta", price: 110 },
    { name: "Sprite", nameEn: "Sprite", price: 110 },
    {
      name: "Frutti Ekstra", nameEn: "Frutti Extra", price: 110,
      description: "Orman Meyveli · Yeşil Limonlu · Kavunlu",
      descriptionEn: "Forest Berry · Lime · Melon"
    },
    {
      name: "Meyveli Soda", nameEn: "Fruit Soda", price: 70,
      description: "Limon · Elma · Karpuz · Çilek",
      descriptionEn: "Lemon · Apple · Watermelon · Strawberry"
    },
    { name: "Uludağ Efsane Gazoz", nameEn: "Uludag Legendary Soda", price: 110 },
    { name: "Uludağ Soda", nameEn: "Uludag Soda", price: 60 },
    { name: "Uludağ Limonata", nameEn: "Uludag Lemonade", price: 110 },
    { name: "Frappe", nameEn: "Frappe", price: 300 },
    {
      name: "Milkshake (Çikolatalı / Çilekli)", nameEn: "Milkshake (Chocolate / Strawberry)", price: 300
    },
    {
      name: "Meyveli Frozen (Kavunlu / Karpuzlu)", nameEn: "Fruit Frozen (Melon / Watermelon)", price: 300
    },
    { name: "Ayran", nameEn: "Ayran", price: 80 },
    { name: "Churchill", nameEn: "Churchill", price: 110 },
    { name: "Küçük Su", nameEn: "Small Water", price: 30 },
    { name: "Büyük Su", nameEn: "Large Water", price: 60 },
  ],
  rakı_çeşitleri: [
    { name: "Yeni Rakı Kadeh", nameEn: "Yeni Rakı (Glass)", price: 400 },
    { name: "Yeni Rakı 20 Cl", nameEn: "Yeni Rakı 20 Cl", price: 1100 },
    { name: "Yeni Rakı 35 Cl", nameEn: "Yeni Rakı 35 Cl", price: 1300 },
    { name: "Yeni Rakı 50 Cl", nameEn: "Yeni Rakı 50 Cl", price: 1800 },
    { name: "Yeni Rakı 70 Cl", nameEn: "Yeni Rakı 70 Cl", price: 2300 },
    { name: "Tekirdağ Yaş Üzüm Kadeh", nameEn: "Tekirdağ Fresh Grape (Glass)", price: null },
    { name: "Tekirdağ Yaş Üzüm 35 Cl", nameEn: "Tekirdağ Fresh Grape 35 Cl", price: null },
    { name: "Tekirdağ Yaş Üzüm 50 Cl", nameEn: "Tekirdağ Fresh Grape 50 Cl", price: null },
    { name: "Tekirdağ Yaş Üzüm 70 Cl", nameEn: "Tekirdağ Fresh Grape 70 Cl", price: null },
    { name: "Efe Yaş Üzüm 35 Cl", nameEn: "Efe Fresh Grape 35 Cl", price: null },
    { name: "Efe Yaş Üzüm 50 Cl", nameEn: "Efe Fresh Grape 50 Cl", price: null },
    { name: "Efe Yaş Üzüm 70 Cl", nameEn: "Efe Fresh Grape 70 Cl", price: null },
    { name: "Efe Gold 35 Cl", nameEn: "Efe Gold 35 Cl", price: 1600 },
    { name: "Efe Gold 50 Cl", nameEn: "Efe Gold 50 Cl", price: 2200 },
    { name: "Efe Gold 70 Cl", nameEn: "Efe Gold 70 Cl", price: 2800 },
  ],
  şarap_çeşitleri: [
    { name: "Sevilen Majestik Mini Şişe", nameEn: "Sevilen Majestik Mini Bottle", price: 600 },
    {
      name: "Sevilen İsabey Sauvignon Blanc 70 Cl", nameEn: "Sevilen İsabey Sauvignon Blanc 70 Cl", price: 1900,
      description: "Beyaz şarap", descriptionEn: "White wine"
    },
    {
      name: "Sevilen İsabey Sauvignon Füme Blanc", nameEn: "Sevilen İsabey Sauvignon Fumé Blanc", price: 1900,
      description: "Beyaz şarap", descriptionEn: "White wine"
    },
    {
      name: "Sevilen Blush 70 Cl", nameEn: "Sevilen Blush 70 Cl", price: 1900,
      description: "Roze şarap", descriptionEn: "Rosé wine"
    },
    {
      name: "Sevilen İsabey Merlot & Cabernet Sauvignon", nameEn: "Sevilen İsabey Merlot & Cabernet Sauvignon", price: 1900,
      description: "Kırmızı şarap", descriptionEn: "Red wine"
    },
    {
      name: "Sevilen Parsel No IX Cabernet Sauvignon", nameEn: "Sevilen Parcel No IX Cabernet Sauvignon", price: 1900,
      description: "Kırmızı şarap", descriptionEn: "Red wine"
    },
    {
      name: "Sevilen 900 Magnum", nameEn: "Sevilen 900 Magnum", price: null,
      description: "1.5 litre magnum şişe", descriptionEn: "1.5 litre magnum bottle"
    },
  ],
  bira_çeşitleri: [
    { name: "Tuborg Gold", nameEn: "Tuborg Gold", price: 250 },
    { name: "Carlsberg", nameEn: "Carlsberg", price: 280 },
    { name: "Carlsberg Luna", nameEn: "Carlsberg Luna", price: 280 },
    { name: "Amber (Tuborg Filtresiz)", nameEn: "Amber – Tuborg Unfiltered", price: null },
    { name: "Frederic Marzen", nameEn: "Frederic Märzen", price: 350 },
    { name: "Wheat IPA", nameEn: "Wheat IPA", price: null },
    { name: "Brown Ale", nameEn: "Brown Ale", price: null },
    { name: "Local Yakıma IPA", nameEn: "Local Yakima IPA", price: null },
    { name: "Sol", nameEn: "Sol", price: 350 },
    { name: "Desperados", nameEn: "Desperados", price: 350 },
    { name: "Blanc", nameEn: "Blanc", price: 350 },
    { name: "India", nameEn: "India", price: null },
  ]
};

const QRMenuAksam = () => {
  const { isDark, toggleDark } = useTheme();
  const [selectedCategory, setSelectedCategory] = useState('başlangıçlar');
  const [language, setLanguage] = useState('tr');
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const catLabel = (cat) => CATEGORY_LABELS[language][cat] || cat;

  const searchResults = searchQuery.trim()
    ? Object.entries(menuData).reduce((acc, [cat, items]) => {
      const q = searchQuery.toLowerCase();
      const matched = items.filter(item =>
        item.name.toLowerCase().includes(q) ||
        item.nameEn.toLowerCase().includes(q) ||
        (item.description || '').toLowerCase().includes(q) ||
        (item.descriptionEn || '').toLowerCase().includes(q)
      );
      if (matched.length > 0) acc.push({ cat, items: matched });
      return acc;
    }, [])
    : null;

  const isSearching = searchQuery.trim().length > 0;
  const totalResults = searchResults ? searchResults.reduce((s, g) => s + g.items.length, 0) : 0;
  const displayGroups = isSearching
    ? searchResults
    : [{ cat: selectedCategory, items: menuData[selectedCategory] || [] }];

  const priceLabel = (price) =>
    price != null ? `${price} ₺` : (language === 'tr' ? 'Sorunuz' : 'Ask staff');

  return (
    <div className="min-h-screen bg-stone-50 dark:bg-neutral-950 transition-colors duration-300">

      {/* Header */}
      <div className="relative">
        <img
          src={process.env.PUBLIC_URL + '/background.png'}
          alt="Yonca Beach"
          className="w-full h-48 sm:h-64 object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/10 to-black/80" />
        <div className="absolute bottom-0 left-0 right-0 p-5 text-center">
          <h1 className="font-brand text-2xl sm:text-3xl font-bold text-white drop-shadow-lg tracking-wide">
            Yonca Beach & Restaurant
          </h1>
          <p className="text-white/75 text-sm mt-1 font-medium tracking-widest uppercase">
            {language === 'tr' ? 'Akşam Menüsü' : 'Evening Menu'}
          </p>
        </div>
      </div>

      {/* Sticky nav */}
      <div className="sticky top-0 z-20 bg-white/95 dark:bg-neutral-950/95 backdrop-blur-md border-b border-stone-200 dark:border-neutral-800 transition-colors duration-300">

        {/* Search + controls */}
        <div className="flex items-center gap-2 px-3 pt-3 pb-2">
          <div className="flex-1 flex items-center gap-2 bg-stone-100 dark:bg-neutral-800 rounded-xl px-3 py-2.5 transition-colors">
            <Search className="w-4 h-4 text-stone-400 dark:text-neutral-500 flex-shrink-0" />
            <input
              type="text"
              placeholder={language === 'tr' ? 'Ürün ara...' : 'Search menu...'}
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
              className="flex-1 bg-transparent text-sm text-stone-700 dark:text-neutral-200 placeholder-stone-400 dark:placeholder-neutral-500 outline-none min-w-0"
            />
            {searchQuery && (
              <button onClick={() => setSearchQuery('')} className="flex-shrink-0">
                <X className="w-4 h-4 text-stone-400 dark:text-neutral-500" />
              </button>
            )}
          </div>
          <button
            onClick={() => setLanguage(l => l === 'tr' ? 'en' : 'tr')}
            className="px-3 py-2.5 rounded-xl bg-stone-100 dark:bg-neutral-800 text-xs font-bold text-stone-600 dark:text-neutral-300 hover:bg-stone-200 dark:hover:bg-neutral-700 transition-colors flex-shrink-0"
          >
            {language === 'tr' ? 'EN' : 'TR'}
          </button>
          <button
            onClick={toggleDark}
            className="p-2.5 rounded-xl bg-stone-100 dark:bg-neutral-800 text-stone-600 dark:text-neutral-300 hover:bg-stone-200 dark:hover:bg-neutral-700 transition-colors flex-shrink-0"
          >
            {isDark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
          </button>
        </div>

        {/* Category tabs */}
        {!isSearching && (
          <div className="overflow-x-auto scrollbar-hide">
            <div className="flex gap-1.5 px-3 pb-3 min-w-max">
              <button
                onClick={() => navigate('/')}
                className="px-3.5 py-1.5 rounded-full text-xs font-semibold whitespace-nowrap bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-400 hover:bg-amber-200 dark:hover:bg-amber-900/50 transition-all flex items-center gap-1"
              >
                <ArrowLeft className="w-3 h-3" />
                {language === 'tr' ? 'Gündüz Menüsü' : 'Day Menu'}
              </button>
              {Object.keys(menuData).map(cat => (
                <button
                  key={cat}
                  onClick={() => setSelectedCategory(cat)}
                  className={`px-3.5 py-1.5 rounded-full text-xs font-semibold whitespace-nowrap transition-all ${selectedCategory === cat
                    ? 'bg-teal-500 text-white shadow-sm'
                    : 'bg-stone-100 dark:bg-neutral-800 text-stone-600 dark:text-neutral-400 hover:bg-stone-200 dark:hover:bg-neutral-700'
                    }`}
                >
                  {catLabel(cat)}
                </button>
              ))}
            </div>
          </div>
        )}

        {isSearching && (
          <div className="px-4 pb-3">
            <span className="text-xs text-stone-400 dark:text-neutral-500">
              {language === 'tr'
                ? `${totalResults} ürün bulundu`
                : `${totalResults} item${totalResults !== 1 ? 's' : ''} found`}
            </span>
          </div>
        )}
      </div>

      {/* Menu content */}
      <div className="px-4 py-5 space-y-3 max-w-2xl mx-auto">
        {displayGroups.length === 0 ? (
          <div className="text-center py-20">
            <Search className="w-10 h-10 mx-auto mb-3 text-stone-300 dark:text-neutral-700" />
            <p className="text-sm text-stone-400 dark:text-neutral-500">
              {language === 'tr' ? 'Ürün bulunamadı' : 'No items found'}
            </p>
          </div>
        ) : (
          displayGroups.map(({ cat, items }) => (
            <div key={cat} className="bg-white dark:bg-neutral-900 rounded-2xl overflow-hidden shadow-sm border border-stone-100 dark:border-neutral-800 transition-colors duration-300">
              {isSearching && (
                <div className="px-4 pt-4 pb-1">
                  <span className="text-xs font-bold text-teal-600 dark:text-teal-400 uppercase tracking-widest">
                    {catLabel(cat)}
                  </span>
                </div>
              )}
              <div className="divide-y divide-stone-100 dark:divide-neutral-800">
                {items.map((item, idx) => (
                  <div key={idx} className="px-4 py-4">
                    <div className="flex justify-between items-start gap-3">
                      <div className="flex-1 min-w-0">
                        <p className="font-semibold text-stone-800 dark:text-neutral-100 text-sm leading-snug">
                          {language === 'tr' ? item.name : item.nameEn}
                        </p>
                        {language === 'tr' && item.nameEn && (
                          <p className="text-xs text-stone-400 dark:text-neutral-500 mt-0.5 italic">
                            {item.nameEn}
                          </p>
                        )}
                        {(item.description || item.descriptionEn) && (
                          <p className="text-xs text-stone-500 dark:text-neutral-400 mt-1.5 leading-relaxed">
                            {language === 'tr'
                              ? item.description
                              : (item.descriptionEn || item.description)}
                          </p>
                        )}
                      </div>
                      <span className={`font-bold text-sm flex-shrink-0 mt-0.5 ${item.price != null
                        ? 'text-teal-600 dark:text-teal-400'
                        : 'text-stone-400 dark:text-neutral-600 text-xs font-medium'
                        }`}>
                        {priceLabel(item.price)}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))
        )}
      </div>

      {/* Footer */}
      <div className="px-4 pt-2 pb-10 text-center">
        <p className="text-xs text-stone-300 dark:text-neutral-700">
          Yonca Beach & Restaurant &mdash; {language === 'tr' ? 'Afiyet olsun!' : 'Enjoy your meal!'}
        </p>
      </div>
    </div>
  );
};

export default QRMenuAksam;
